<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      :content-style="{'height':'100%','display':'flex','flex-direction':'column'}"
      not-footer-padding
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parentTable>
        <template #filter-group>
          <app-filter-group
              :reset="false"
              :query="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                @confirm="$gjNoticeQuery()"
                @input="$gjNoticeQuery()"
                :singe-input="true"
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['110px', '200px']"
            >
            </gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              name="transferProductAddModal"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              adapt-parent
              :offset-height="62"
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
import {isMeaningful} from "@/utils/common";
import {getPurchasePlanPageAddProduct} from "@/api/purchase";
import {ProductEnum} from "@/utils/options";

export default {
  name: "app-add-product-modal",
  mixins: [modalMixIn, queryMixin, selectionMixin],
  props: {
    hideSkuList: {
      required: true,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      moduleName: "app-purchase-plan-add-product-modal",
      tableData: [],
      columns: [
        {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px'},
        {id: 'name', header: '产品名称', field: 'name', width: '200px'},
        {id: 'sku', header: 'SKU', field: 'sku', minWidth: '100px'},
        {
          id: 'productType',
          header: '产品类型',
          field: 'option:productType',
          options: [{id: "Product", text: "普通产品"}, {id: "Assembly", text: "组合产品"}],
          minWidth: '100px'
        },
        {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '100px'},
        {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '100px'},
      ],
      filter: {
        keyword: {
          key: 'skuList',
          value: null
        },
      },
      option: {
        keyword: [
          {id: 'skuList', text: 'SKU', moreShow: true},
          {id: 'productName', text: '产品名称'},
        ],
      },
      productTypeOption: ProductEnum.typeOption
    }
  },
  created() {
    this.sort.prop = 'sku';
  },
  methods: {
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          hideSkuList: this.hideSkuList,
          status:'Active',
          [this.filter.keyword.key]: this.filter.keyword.value,
        },
        ...this.queryPagination,
        ...this.querySort
      };
      // 查询
      this.loading = true;
      if (params.model.skuList) {
        params.model['skuList'] = params.model['skuList'].split(",")
      } else {
        params.model.skuList = [];
      }
      getPurchasePlanPageAddProduct(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
    },
    confirm() {
      if (this.selectedRows.length === 0) {
        this.$gjMessage.error('请勾选产品');
        return;
      }
      this.$emit('select', this.selectedRows);
      this.$gjDestroy();
    }
  }
}
</script>

<style scoped>
.add-product-btn {
  margin: 5px 0 10px;
}
</style>
